/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_Ai_NoteInputs */

const tr_landing_integrations_ai_note = /** @type {(inputs: Landing_Integrations_Ai_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi API anahtarınızı bağlayın ya da bizim kredimizle kullanın`)
};

const en_landing_integrations_ai_note = /** @type {(inputs: Landing_Integrations_Ai_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your own API key, or use our credits`)
};

const de_landing_integrations_ai_note = /** @type {(inputs: Landing_Integrations_Ai_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenen Schlüssel anbinden oder unser Guthaben nutzen`)
};

const ru_landing_integrations_ai_note = /** @type {(inputs: Landing_Integrations_Ai_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключите свой ключ или используйте наши кредиты`)
};

/**
* | output |
* | --- |
* | "Connect your own API key, or use our credits" |
*
* @param {Landing_Integrations_Ai_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_ai_note = /** @type {((inputs?: Landing_Integrations_Ai_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_Ai_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_ai_note(inputs)
	if (locale === "de") return de_landing_integrations_ai_note(inputs)
	if (locale === "ru") return ru_landing_integrations_ai_note(inputs)
	return tr_landing_integrations_ai_note(inputs)
});